import { apiDelete, apiGet, apiPost, apiPut } from './index'
import type {
  CreateGlobalIngestKeyPayload,
  CreateGlobalIngestKeyResponse,
  DeleteGlobalIngestKeyResponse,
  ListGlobalIngestKeysResponse,
  UpdateGlobalIngestKeyPayload,
  UpdateGlobalIngestKeyResponse,
} from '../types/ingest'

export const getGlobalIngestKeys = async (): Promise<ListGlobalIngestKeysResponse> => {
  return apiGet<ListGlobalIngestKeysResponse>('ingest-keys/global')
}

export const createGlobalIngestKey = async (
  payload: CreateGlobalIngestKeyPayload,
): Promise<CreateGlobalIngestKeyResponse> => {
  return apiPost<CreateGlobalIngestKeyResponse>('ingest-keys/global', payload)
}

export const updateGlobalIngestKey = async (
  id: string,
  payload: UpdateGlobalIngestKeyPayload,
): Promise<UpdateGlobalIngestKeyResponse> => {
  return apiPut<UpdateGlobalIngestKeyResponse>(`ingest-keys/global/${encodeURIComponent(id)}`, payload)
}

export const deleteGlobalIngestKey = async (id: string): Promise<DeleteGlobalIngestKeyResponse> => {
  return apiDelete<DeleteGlobalIngestKeyResponse>(`ingest-keys/global/${encodeURIComponent(id)}`)
}
